export default {
  title: 'Gestion des rôles',
  subtitle: 'Gérez les comptes et les accès de vos collaborateurs.',
  create: 'Créer un compte',
  search: 'Rechercher un collaborateur',
  count: '{n} collaborateurs',
  columns: {
    member: 'Collaborateur',
    identifier: 'Identifiant',
    role: 'Rôle',
    actions: 'Actions',
  },
  you: 'Vous',
  edit: 'Modifier',
  editLabel: 'Modifier le compte de {name}',
  empty: 'Aucun collaborateur ne correspond à votre recherche.',
  rolesInfo: 'Admin peut gérer les comptes et les rôles. User accède aux outils de One.',
  dialog: {
    eyebrow: 'Gestion des rôles',
    create: 'Créer un compte',
    edit: 'Modifier le compte',
    delete: 'Supprimer le compte ?',
    firstName: 'Prénom',
    lastName: 'Nom',
    identifierPlaceholder: 'prenom.nom',
    role: 'Rôle',
    userHelper: 'Accès aux outils de One',
    adminHelper: 'Gestion des comptes et des rôles',
    submitCreate: 'Créer le compte',
    deleteAccount: 'Supprimer le compte',
    deleteSelf: 'Votre compte connecté ne peut pas être supprimé.',
    deleteConfirm: 'Confirmez-vous la suppression du compte de {name} ?',
    deleteDescription: 'Ce collaborateur n’aura plus accès à One.',
  },
  errors: {
    required: 'Renseignez tous les champs du compte.',
    identifier: 'Cet identifiant est déjà utilisé.',
    email: 'Cette adresse email est déjà associée à un compte.',
  },
  notices: {
    created: 'Le compte a été créé.',
    updated: 'Le compte a été mis à jour.',
    deleted: 'Le compte de {name} a été supprimé.',
  },
  denied: {
    title: 'Accès réservé aux administrateurs',
    text: 'Votre rôle User vous donne accès aux outils de One. La gestion des comptes est réservée aux administrateurs.',
    back: 'Revenir à One',
  },
};
